import { IConfigModule } from "build/types/configs";

const config : IConfigModule = 
{
  "version": "2.0.0",
  "allowReferral": false,
  "filterPrizes": true,
  "buttonsStart": [
    "signIn",
    "signUp",
    "google",
    "facebook"
  ],
  "positiveLogoUrls": [
    "/terms-and-conditions",
    "/profile",
    "/help",
    "/trivias",
    "/congrats",
    "/ranking/suscribe",
    "/ranking/suscribe/confirm",
    "/end",
    "/trivia/:id",
    "/error/:errorid"
  ],
  "useSecondBackground": [
    "/photographer/start",
    "/album",
    "/album/start"
  ],
  "imageStart": "backgroundImage",
  "welcome": "ImgBackground",
  "legalAgeDate": true,
  "routesHome": [
    "Photos",
    "UploadImage",
  ],
  "routesProfile": [
    "information",
    "address",
    "phone"
  ],
  "notAvailableFields": [
    "curp",
    "nickName",
    "instagram",
    "consumptionCenter",
    "sign"
  ],
  "privacyPolitics": "BACK",
  "cookies": "MX",
  "trivia": {
    "showIntroduction": false,
    "interestsRequired": true
  },
  "notShowFields": ["nickName"],
  stepsNewVersion: true,
  signUp: {
    stepsTop: true,
    useStepBalls: true
  },
  profile: {
    notShowButtonInformation: true
  },
  "album": {
    "Foto": {
      "upload": {
        "isTakeFoto": false,
        "showBackButton": true,
        "showCallbackButton": true
      },
      "list": {
        "v1": true
      }
    }
  }
}

export default config;